.list {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-self: stretch;
  width: 100%;
  align-items: stretch;
  margin-bottom: 70px;
}

.emptyContainer {
  width: 110px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
